import $ from 'jquery';
window.$ = window.jQuery = $;

( function( $ ) {
	"use strict";

	var TLS_Cart = function() {

		var self = this;

		this.updateCart = function(fragments, cart_hash, $thisbutton){
            // console.log('triggerato fragments',fragments);
            // console.log('triggerato cart_hash',cart_hash);
            // console.log('triggerato thisbutton',$thisbutton);
            // var $obj_button = $('*[data-cart_item_key="'+$thisbutton+'"]');
            // var $row   = $obj_button.closest( '.woocommerce-mini-cart-item' );
            // console.log('triggerato row',$row);
            // $('#mini-cart .offcanvas-body').html('');
            // $('#mini-cart .offcanvas-body').append(cart_hash);
        };

        this.onRemoveFromCart = function() {
            var $thisbutton = $( this ),
			$row        = $thisbutton.closest( '.woocommerce-mini-cart-item' );
            $row.remove();
        };

		this.hideQuantity = function()
		{
			if( ! $('.woocommerce-cart-form') )
				return;

			$('.cart .cart_item').each(function () 
			{
				const $qty = $(this).find('input.qty');
				if($qty.attr('type') == 'hidden'){
					$(this).find('.quantity').css("display", "none");
				}
			});
		};

		/**
		 * Event binding.
		 */
		this.bind = function() {

            // $( document ).on('removed_from_cart updated_cart_totals', self.updateCart );
            // $( document.body )
			// .on( 'click', '#mini-cart .remove_from_cart_button', self.onRemoveFromCart );

			$( document ).on( 'ready', self.hideQuantity);
			$( document ).on( 'updated_wc_div', self.hideQuantity);
		};

		/**
		 * Initialization.
		 */
		this.init = function() {
			self.bind();
		};

		this.init();

	};

	( new TLS_Cart() );

} )( jQuery );

